export default "__VITE_ASSET__572c60a4__"